import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {objectContentElementInitialState, updateState,} from "../../../../common/utils/helpers";

const initialState = {
  package: { ...objectContentElementInitialState },

  creationNouvelleSouscription: { ...objectContentElementInitialState },
  existForfaitAvecMemeExercice: false,
};

/*-------------------------------------------------GET-PACKAGE-FOR-SOUSCRIPTION---------------------------------------------------*/
const getPackageForSouscription = (state) => {
  return updateState("package", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const getPackageForSouscriptionSuccess = (state, payload) => {
  return updateState("package", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getPackageForSouscriptionFail = (state, payload) => {
  return updateState("package", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};
/*-------------------------------------------------CREATION_NOUVELLE_SOUSCRIPTION----------------------------------------------------*/
const creationNouvelleSouscription = (state) => {
  return updateState("creationNouvelleSouscription", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const creationNouvelleSouscriptionSuccess = (state, payload) => {
  return updateState("creationNouvelleSouscription", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const creationNouvelleSouscriptionFail = (state, payload) => {
  return updateState("creationNouvelleSouscription", state, {
    ...objectContentElementInitialState,
  });
};

const creationNouvelleSouscriptionReinitialization = (state) => {
  return updateState("creationNouvelleSouscription", state, {
    ...objectContentElementInitialState,
  });
};

/*-------------------------------------------------EXIST_FORFAIT_AVEC_MEME_EXERCICE----------------------------------------------------*/
const existForfaitAvecMemeExercice = (state) => {
  return updateState("existForfaitAvecMemeExercice", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const existForfaitAvecMemeExerciceSuccess = (state, payload) => {
  return updateState("existForfaitAvecMemeExercice", state, {
    existForfaitAvecMemeExercice: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const existForfaitAvecMemeExerciceFail = (state, payload) => {
  return updateState("existForfaitAvecMemeExercice", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const existForfaitAvecMemeExerciceReinitialization = (state) => {
  return updateState("existForfaitAvecMemeExercice", state, {
    existForfaitAvecMemeExercice: false,
    isLoading: false,
    isSuccessed: false,
  });
};

/*************************************************************************** */
const nouvelleSouscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    /*------------------------------------------------GET-PACKAGE-FOR-SOUSCRIPTION---------------------------------------------------*/
    case ActionsTypes.GET_PACKAGE_FOR_SOUSCRIPTION:
      return getPackageForSouscription(state, action);
    case ActionsTypes.GET_PACKAGE_FOR_SOUSCRIPTION_SUCCESS:
      return getPackageForSouscriptionSuccess(state, action.payload);
    case ActionsTypes.GET_PACKAGE_FOR_SOUSCRIPTION_FAIL:
      return getPackageForSouscriptionFail(state, action.payload);
    case ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION:
      return creationNouvelleSouscription(state, action);
    case ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION_SUCCESS:
      return creationNouvelleSouscriptionSuccess(state, action.payload);
    case ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION_FAIL:
      return creationNouvelleSouscriptionFail(state, action.payload);
    case ActionsTypes.CREATION_NOUVELLE_SOUSCRIPTION_REINITIALIZATION:
      return creationNouvelleSouscriptionReinitialization(state);
    case ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE:
      return existForfaitAvecMemeExercice(state, action);
    case ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE_SUCCESS:
      return existForfaitAvecMemeExerciceSuccess(state, action.payload);
    case ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE_FAIL:
      return existForfaitAvecMemeExerciceFail(state, action.payload);
    case ActionsTypes.EXIST_FORFAIT_AVEC_MEME_EXERCICE_REINITIALIZATION:
      return existForfaitAvecMemeExerciceReinitialization(state);
    default:
      return state;
  }
};

export default nouvelleSouscriptionReducer;
